<template>
  <v-select
    :options="prepareOptions(options)"
    @input="input"
    :value="value"
    :reduce="(option) => option.id"
    label="label"
    :selectable="(option) => !option.isHeader && !option.isfix"
    :clearable="false"
    :disabled="disabled"
  >
    <template #option="option">
      <div
        class="ml-0 pl-0"
        style="color: #333; margin-left: 0; padding-left: 0;"
        v-if="option.isHeader"
      >
        <i v-if="option.icon" class="far" :class="option.icon"></i>
        <i v-else class="far fa-arrow-right"></i>
        {{ option.group }}
      </div>
      <span v-else class="ml-5">{{ option.text }}</span>
    </template>

    <template #selected-option="option">
      <div class="d-flex flex-column">
        <small class="font-bold text-xs">{{ option.group }}</small>
        <span>{{ option.text }}</span>
      </div>
    </template>

    <template #search="{ attributes, events }">
      <input class="vs__search" style="height: 38px;" v-bind="attributes" v-on="events" />
    </template>

    <template #open-indicator="{}">
      <span v-if="disabled"></span>
    </template>
  </v-select>
</template>

<script lang="ts">
  import { Component, Emit, Prop, Vue } from "vue-property-decorator";
  import { SelectListItemGroup } from "@/components/Misc/SelectListItemGroup";
  import { sortBy } from 'lodash';

  @Component
  export default class GroupedSelect extends Vue {
    @Prop() options!: SelectListItemGroup[];
    @Prop() value!: number;
    @Prop() disabled!: boolean;

    prepareOptions(options: SelectListItemGroup[]) {
      const result = [];

      sortBy(options, 'text').forEach((group) => {
        result.push({
          id: null,
          isHeader: true,
          group: group.text,
          icon: group.icon,
          label: group.text + group.items.map(i => i.text).join() //for search
        });

        if (!group.items.length)
        {
          result.push({
            id: null,
            text: 'This category has no available types',
            group: group.text,
            isHeader: false,
            icon: '',
            isfix: true,
            label: group.text
          });
        }

        sortBy(group.items, 'text').forEach((item) => {
          result.push({
            id: item.id,
            text: item.text,
            group: group.text,
            isHeader: false,
            icon: item.icon,
            label: group.text + item.text
          });
        });
      });

      return result;
    }

    @Emit("input")
    input(value: any) {
      return value;
    }
  }
</script>

<style lang="scss">
  .vs__dropdown-option {
    padding-left: 10px;
  }
</style>
